"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiCurrencyMoneyModel = void 0;
const Money_1 = require("./Money");
const validator_1 = require("@leavy/validator");
const PropertyConstraint_1 = require("../../infrastructure/validation/PropertyConstraint");
const RecordType_1 = require("../../infrastructure/validation/RecordType");
const IsRecord_1 = require("../../infrastructure/validation/IsRecord");
const Currency_1 = require("../domain/Currency");
class MultiCurrencyMoneyModel {
}
__decorate([
    (0, validator_1.Type)(() => Money_1.MoneyModel),
    (0, validator_1.IsInstance)(Money_1.MoneyModel),
    (0, validator_1.ValidateNested)(),
    __metadata("design:type", Money_1.MoneyModel)
], MultiCurrencyMoneyModel.prototype, "base", void 0);
__decorate([
    (0, RecordType_1.RecordType)(() => Number, {
        includeKey: (key) => Currency_1.Currency.isCurrency(key),
        transformBefore: (rawRecordValue => {
            const parsedNumber = Number(rawRecordValue);
            return !Number.isNaN(parsedNumber) ? parsedNumber : rawRecordValue;
        }),
    }),
    (0, IsRecord_1.IsRecord)(String, Number),
    (0, PropertyConstraint_1.PropertyConstraint)(propertyKey => Currency_1.Currency.isCurrency(propertyKey)),
    __metadata("design:type", Object)
], MultiCurrencyMoneyModel.prototype, "currencies", void 0);
exports.MultiCurrencyMoneyModel = MultiCurrencyMoneyModel;
//# sourceMappingURL=MultiCurrencyMoney.js.map